<script>
export default {
  props: ["message"]
};
</script>

<template>
  <transition name="fade" mode="out-in">
    <div class="error-button" v-tooltip.left="message">!</div>
  </transition>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/_Shared/ErrorInput.vue